import React from "react";

const AboutUs =()=>{

    return (
        <>
            <section className="about container" name="about">
                {/* <div className="about__container"> */}
                    <div className="about__text">
                        <h2>O nas</h2>
                        <p>Nori grape silver beet broccoli kombu beet greens fava bean potato quandong celery. Bunya nuts black-eyed pea prairie turnip leek      lentil turnip greens parsnip.</p>
                        <div className="about__text-signature"></div>
                    </div>
                {/* </div> */}
                <div className="about__image"></div>
            </section>
        </>
    )

}

export default AboutUs;